export const CATALOG_OPTIONS = [
  "legalPersonName",
  "inn",
  "legalAddress",
  "executiveFullName",
  "executiveEmail",
  "candidateType",
  "executiveWorkPhone",
  "isCompetitive",
  "distanceToNearestDealer",
  "status",
  "audit",
];
